export default "__VITE_ASSET__CR6OlNU2__"